import React from 'react'
import { Box, styled, Theme, Typography, useMediaQuery } from '@mui/material'
import { PersonIcon } from '../icons'
import { AppButton, Modal } from '../ui'
import { Divider } from '@/components/ui/Divider'
import { HelpBlock } from '../help/HelpBlock'
import Link from 'next/link'
import { usePushNotification, useRegistrant } from '@/hooks'
import Grid from '@mui/material/Grid2'
import { BadgeWithCount } from '@/components/icons/BadgeWithCount'
import { useAddToHomeScreen } from '@/hooks/useAddToHomeScreen'

interface Props {
  isVisible: boolean
  onClose: () => void
}

const PrimaryLinks = styled(Grid)`
  height: calc(100% - 50px);
`

const IconWrapper = styled(Box)`
  width: 24px;
  height: 24px;
  margin-right: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.custom.colors.common.black};

  & > svg {
    width: 100%;
    height: 100%;
  }
`

const StyledPhone = styled(Typography)`
  color: ${({ theme }) => theme.custom.colors.common.black};
`

const StyledDivider = styled(Divider)`
  margin-top: ${({ theme }) => theme.spacing(3)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`

export const MenuModal: React.FC<Props> = ({ isVisible, onClose }) => {
  const { registrant } = useRegistrant()
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.only('xs'))
  const { isReady, unreadCount } = usePushNotification()
  const { isStandAlone, canBeInstalled, showPrompt } = useAddToHomeScreen()

  return (
    <Modal isOpen={isVisible} onClose={onClose}>
      <Box
        sx={{
          height: '100%',
          mt: isMobile ? -2 : 0,
        }}
      >
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid container size={{ xs: 'grow' }} justifyContent="flex-start" alignItems="center">
            <IconWrapper>
              <PersonIcon />
            </IconWrapper>
            <StyledPhone variant="body1">{registrant?.user.phone || 'Mobile number not provided'}</StyledPhone>
          </Grid>
        </Grid>
        <StyledDivider sx={{ mt: 2 }} />
        <PrimaryLinks
          container
          direction="column"
          spacing={4}
          alignItems="stretch"
          justifyContent="space-between"
          wrap="nowrap"
        >
          <Grid container spacing={4} direction="column" alignItems="stretch">
            <Grid>
              <AppButton fullWidth variant="outlined" LinkComponent={Link} href="/registrant/change-organization">
                Select or Add other organizations
              </AppButton>
            </Grid>
            <Grid>
              <AppButton fullWidth variant="outlined" LinkComponent={Link} href="/registrant/editing">
                Edit Profile
              </AppButton>
            </Grid>
            <Grid>
              <AppButton fullWidth variant="outlined" LinkComponent={Link} href="/registrant/messages">
                Messages{isReady && unreadCount > 0 && <BadgeWithCount placement="menu" count={unreadCount} />}
              </AppButton>
            </Grid>
            {!isStandAlone && canBeInstalled && (
              <Grid>
                <AppButton
                  fullWidth
                  variant="outlined"
                  onClick={() => {
                    onClose()
                    setTimeout(() => {
                      showPrompt()
                    }, 100)
                  }}
                >
                  Save Dashboard to Home Screen
                </AppButton>
              </Grid>
            )}
          </Grid>
          <Grid>
            <HelpBlock />
          </Grid>
        </PrimaryLinks>
      </Box>
    </Modal>
  )
}
